import { useSelector } from 'react-redux';
import { isLoadingSelector } from '../../../../../../../store/app/selector';
import { getResendTimerSelector } from '../../../../../../../store/auth/selector';
import isBefore from 'date-fns/isBefore';

export function useViewModel() {
  const resendTimer = useSelector(getResendTimerSelector);

  return {
    resendTimer,
    canResend: resendTimer && isBefore(new Date(), resendTimer),
  };
}
